module.exports = __webpack_public_path__ + "img/product-11.e14cb80a.jpg";